import React from 'react';
import { motion } from 'framer-motion';
import { WHATSAPP_LINKS } from '../../config/whatsapp';

const ComplementaryExams = () => {

  const examsList = [
    'Audiometria',
    'Espirometria',
    'Acuidade Visual',
    'Audiometria Tonal',
    'Avaliação Psicossocial',
    'Eletrocardiograma',
    'Eletroencefalograma',
    'Raio-X',
    'Exames Laboratoriais',
    'Avaliação Psicológica',
    'Avaliação Fonoaudiológica',
    'Teste de Romberg'
  ];

  return (
    <section className="py-16 bg-white">
      <div className="container mx-auto px-4">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
          viewport={{ once: true }}
          className="text-center mb-12"
        >
          <h2 className="text-3xl font-bold text-teal-700 mb-4">Exames Complementares</h2>
          <p className="text-gray-700 max-w-3xl mx-auto">
            Realizamos todos os exames complementares necessários para o cumprimento 
            das normas regulamentadoras e para a avaliação completa da saúde ocupacional 
            dos seus colaboradores.
          </p>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 mb-10">
          {examsList.map((exam, index) => (
            <motion.div
              key={index}
              initial={{ opacity: 0, scale: 0.9 }}
              whileInView={{ opacity: 1, scale: 1 }}
              transition={{ duration: 0.5, delay: index * 0.05 }}
              viewport={{ once: true }}
              className="bg-gray-50 p-4 rounded-lg shadow-sm border border-gray-100 hover:shadow-md transition-shadow"
            >
              <div className="flex items-center">
                <div className="w-8 h-8 bg-teal-100 text-teal-700 rounded-full flex items-center justify-center mr-3">
                  <svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" />
                  </svg>
                </div>
                <span className="text-gray-700">{exam}</span>
              </div>
            </motion.div>
          ))}
        </div>

        <div className="text-center">
          <a 
            href={WHATSAPP_LINKS.exames}
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center bg-teal-600 hover:bg-teal-700 text-white font-medium py-2 px-6 rounded-md transition-colors"
          >
            <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 mr-2" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z" />
            </svg>
            Agendar Exames
          </a>
        </div>
      </div>
    </section>
  );
};

export default ComplementaryExams;